function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Wrapper around a type that exposes either itself or an object
 *   containing a display/value pairing. For use in option inputs
 *   so a user can easily define rendering logic separate from
 *   a field value.
 */

/**
 * Returns the value of a given OwnUpOption.
 *
 * @param option - Option to unwrap.
 */
export var getOptionValue = function getOptionValue(option) {
  if (_typeof(option) === 'object' && 'value' in option) {
    return option;
  }

  return {
    value: option,
    display: option,
    className: undefined,
    variant: undefined
  };
};
/**
 * Constant representation that can be interpreted as a break.
 *   Up to the implementer to allow it to be used.
 */

export var OwnUpOptionBreak = '----BREAK----';